/** @file The options of a command's top-level choice field (e.g. bone.setInherit `value`), from its schema. */
import { commandSchema } from './commandSchema';

/** Option values as strings; [] when `key` is not a choice of `command`. */
export function choiceOptions(command: string, key: string): string[] {
  const field = commandSchema(command).fields.find((f) => f.key === key);
  return field?.kind === 'choice' ? field.options.map(String) : [];
}
